import { ready } from './utilities.js';
import './fontawesome-subset.js';
import './fontawesome.js';

(function main($) {

	function editYTViews(data) {
		var counts = Array.prototype.slice.call(document.querySelectorAll('.views-count'));
		var id, match;

		counts.forEach(function(count) {
			id = count.getAttribute('data-id');

			match = data.items.find(function(item) {
				return item.id === id;
			});

			count.textContent = match.statistics.viewCount;
		});
	}

	function grabYTViews() {
		var ids = Array.prototype.slice.call(document.querySelectorAll('.views-count[data-id]'));
		var idString = ids.reduce(function(idString, element) {
			return idString + ',' + element.getAttribute('data-id');
		}, '');
		var data;

		if (ids.length > 0) {
			var request = gapi.client.youtube.videos.list({
				id: idString,
				part: 'statistics'
			});

			request.execute(function(response) {
				data = response.result;
				editYTViews(data);
			});
		}
	};

	function handleAPILoaded() {
		grabYTViews();
	}

	function loadAPIClientInterfaces() {
		gapi.client.load('youtube', 'v3', handleAPILoaded);
	}

	function start() {
		gapi.client.init({
			'apiKey': 'AIzaSyDWgitzikESh5cRKdNhrSXwkXV1MIkgn4o'
		}).then(loadAPIClientInterfaces);
	};

	window.handleClientLoad = function() {
		gapi.load('client', start);
	};

	function handleNavToggle(event) {
		var menu = document.querySelector('#mobile-nav');
		var toggle = this;

		menu.classList.toggle('active');
		toggle.classList.toggle('open');
	}

	function attachNavHandler() {
		var toggle = document.querySelector('.menu-toggle');
		if (toggle) {
			toggle.addEventListener('click', handleNavToggle);
		}
	}

	function attachStullerFormHelper () {
		if (!window.stuller) {
			window.stuller = {};
		}

		window.stuller.formHelper = function () {
			var pub = {
				setCookie: function (name, value, days) {
					if (days) {
						var date = new Date();
						date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
						var expires = "; expires=" + date.toGMTString();
					}
					else var expires = "";
					document.cookie = name + "=" + value + expires + "; path=/";
				}
			};

			return pub;
		}();
	}

	function playVideo() {
		this.play();
	}

	function loadVideoBG() {
		var video = document.querySelector('.video-bg');
		var videoSources = document.querySelectorAll('.video-bg source[data-src]');
		var source;

		if (video) {
			video.addEventListener('loadeddata', playVideo);

			if (videoSources.length > 0 && window.innerWidth > 768) {
				for (var i = 0; i < videoSources.length; i++) {
					source = videoSources[i].getAttribute('data-src');
					videoSources[i].setAttribute('src', source);

				}
				video.load();
			}
		}
	}

    function stopUnauthorizedAjax() {
	    $("body").ajaxComplete(function (e, r) {
		    if (r.getResponseHeader("Stuller-Ajax-Unauthorized") == "true") {
			    window.location = "<%=Url.Action(Routes.Home.Login()) %>?ReturnURL=" + encodeURIComponent(window.location.pathname + window.location.search);
		    }
	    });
    }

	function init() {
		attachNavHandler();
		stopUnauthorizedAjax();
		attachStullerFormHelper();
	}

	loadVideoBG();
	ready(init);
})($);
